import { render } from "./WysiwygViewer.vue?vue&type=template&id=66e1491a"
import script from "./WysiwygViewer.vue?vue&type=script&lang=js"
export * from "./WysiwygViewer.vue?vue&type=script&lang=js"

import "./WysiwygViewer.vue?vue&type=style&index=0&id=66e1491a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__